import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Pie } from 'react-chartjs-2';
import { fontSizePieChart } from '../../../common/commonFun';

// Register required components and plugins
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const PatientAgeChart = () => {
  const [fontSize, setFontSize] = useState(fontSizePieChart());

  const chartData = {
    labels: ['<30 years', '31-40 years', '41-50 years', '51+ years', 'Prefer not to say'],
    datasets: [
      {
        label: 'Patient Age Distribution',
        data: [15, 15, 30, 61, 10],
        backgroundColor: [
          'rgba(18, 66, 99, 1)', 
          'rgba(66, 105, 130, 1)', 
          'rgba(112, 143, 161, 1)',
          'rgba(161, 178, 194, 1)',
          'rgba(207, 217, 224, 1)',
        ],
        borderWidth: 3,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,
        bottom: 20,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        color: '#54667A',
        font: {
          family: 'Open Sans',
          size: fontSize,
          weight: 600,
        },
        offset: 3,
        formatter: (value, context) => {
          let total = context.chart.data.datasets[0].data.reduce((acc, val) => acc + val, 0);
          let percentage = Math.round((value / total) * 100);
          return `${percentage}%`;
        },
      },
    },
  };

  // Update font size on window resize
  useEffect(() => {
    const handleResize = () => setFontSize(fontSizePieChart());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="col-lg-6">
      <div className="card rounded-0 border-dark-700 h-100 d-flex justify-content-between py-4">
        <div className="card-header bg-transparent border-0">
          <h3 className="text-turquoise fw-bold fs-30 text-center mt-1">Patient age</h3>
        </div>
        <div className="card-body">
          <div>
            <Pie data={chartData} options={chartOptions}  className="pieChart"/>
          </div>
        </div>
        <div className="card-footer bg-transparent border-0">
          <div className="Legend d-flex justify-content-start px-2 flex-wrap">
            <div className="patient-gender-chart color-1 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>&lt;30 Years</div>
            <div className="patient-gender-chart color-2 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>31-40 Years</div>
            <div className="patient-gender-chart color-4 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>41-50 Years</div>
            <div className="patient-gender-chart color-5 fw-bold text-dark-gray fs-20 pe-2 pb-2"><span></span>51+ Years</div>
            <div className="patient-gender-chart color-7 fw-bold text-dark-gray fs-20 pe-2"><span></span>Prefer not to say</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientAgeChart;
